import React from "react";

import TransformingHealthcareWithBlockchain from "../../components/BlogDetails/TransformingHealthcareWithBlockchain";

import LayoutTwo from "../../layouts/LayoutTwo";

const BlogDetailsPage = () => {
  return (
    <LayoutTwo pageTitle={"Blog Details"} item={"BLOG DETAILS"}>
      <TransformingHealthcareWithBlockchain />
    </LayoutTwo>
  );
};

export default BlogDetailsPage;
